"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMolecule = function IconMolecule(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M21.755 10.322A1.5 1.5 0 0 1 19.085 9h-8.17q.084.236.085.5a1.5 1.5 0 0 1-2.755.822l-4.506 7.885a1.499 1.499 0 0 1 2.026.486L10.16 11h9.678l4.396 7.693a1.5 1.5 0 0 1 2.026-.486zM5.765 20.307a1.5 1.5 0 0 1-2.026.486l4.506 7.885A1.499 1.499 0 0 1 11 29.5q-.001.264-.085.5h8.17a1.5 1.5 0 0 1 2.68-1.307L26.16 21h9.678l4.396 7.693a1.5 1.5 0 0 1 2.026-.486l-4.506-7.885A1.5 1.5 0 0 1 35.085 19h-8.17q.084.236.085.5a1.5 1.5 0 0 1-2.765.807L19.84 28h-9.678zM21.765 30.307a1.5 1.5 0 0 1-2.026.486l4.506 7.885A1.5 1.5 0 0 1 26.915 40h8.17a1.5 1.5 0 0 1 2.67-1.322l4.506-7.885a1.499 1.499 0 0 1-2.026-.486L35.84 38h-9.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M13 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-2 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M24 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-2 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9.5 33a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 19.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-2 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M36.5 23a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M45 29.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-2 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M36.5 43a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M29 39.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-2 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M25.5 23a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M24 29.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-2 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};

export { IconMolecule, IconMolecule as default };
